import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { showPopup, closePopup } from '../../actions/uiActions'
import { deleteDatabaseJobFile, getDatabaseJobFiles } from '../../actions/dbFunctionsActions'

function DeleteDbJobFile(props) {
    const [fileIsBeingUsed, setFileIsBeingUsed] = useState(false)
    const [buttonPressed, setButtonPressed] = useState(false)

    // trigger on component mount
    useEffect(() => {
        setFileIsBeingUsed(props.popupInfo.filesBeingUsed.includes(props.popupInfo.targetFile) || props.popupInfo.filesBeingUsed.includes(props.popupInfo.targetFileId))
    }, [])

    function handleClick(event) {
        event.preventDefault()
        props.closePopup()
    }

    function deleteClick(event) {
        event.preventDefault()
        setButtonPressed(true)

        if (props.popupInfo.fileId && props.popupInfo.fileId > 0) {
            let deleteJobReq = props.deleteDatabaseJobFile(props.popupInfo.fileId)

            deleteJobReq.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    props.getDatabaseJobFiles()
                    props.showPopup("infoDbJob", { header: "Delete Job File", message: "Delete Job File Completed" })
                }
            })
        }
    }

    function renderMessage(beingUsed) {
        if (beingUsed) {
            return <>File [{props.popupInfo.targetFile}] is currently selected as part of an existing job, please delete the job first before removing the file</>
        }

        return null
    }

    // This is the render logic, no need to declare another method is a functional component
    return (<Dialog
        open={true}
        onClose={handleClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <CloseIcon onClick={handleClick} className="closePoup" />
        <DialogTitle id="alert-dialog-title" className="changepassdialog">
            {'Delete Database Job File?'}
            {' '}
        </DialogTitle>
        <DialogContent>
            {renderMessage(fileIsBeingUsed)}
            <div className="passwordResetbox">
                <Button
                    variant="contained"
                    disabled={fileIsBeingUsed || buttonPressed}
                    className="btn"
                    onClick={deleteClick}>
                        Delete
                </Button>
            </div>
        </DialogContent>
    </Dialog>)
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ showPopup, closePopup, deleteDatabaseJobFile, getDatabaseJobFiles }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteDbJobFile)